import { create } from 'zustand'

type AlertType = 'success' | 'error'

interface AlertState {
  type: AlertType
  message: string
  show: boolean
  id: number
}

interface AlertActions {
  showAlert: (type: AlertType, message: string) => void
}

export const useAlertStore = create<AlertState & AlertActions>((set) => ({
  type: 'success',
  message: '',
  show: false,
  id: 0,
  showAlert: (type, message) =>
    set({ type, message, show: true, id: Date.now() }),
}))
